import React from "react";

const Workflow = (props) => {
  const buttonProps = props.workflow.saveButtonProps
    ? props.workflow.saveButtonProps
    : {};

  return (
    <div className="mb-3 mt-3">
      <div className="workflow-container workflow-cart-bg-border">
        <div className="row">
          <div className={(props.isCookied ? "col-12 " : "col-9 ") + "pr-0"}>
            <div>
              <b className="mr-1">Reviewing Order:</b>{" "}
              <span>{props.workflow.orderNumber}</span>
            </div>
            <div>
              <b className="mr-1">Placed By:</b>{" "}
              <span>{props.workflow.orderedBy}</span>
            </div>
          </div>
          {!props.isCookied && (
            <div className="col-3">
              <button
                className="btn btn-block btn-success p-0"
                {...buttonProps}
              >
                <b>SAVE</b>
              </button>
            </div>
          )}
        </div>
      </div>
      {props.isCookied && (
        <a
          className="btn btn-block btn-primary mt-2 d-block"
          href={props.workflow.workFlowRedirect}
          role="button"
          type="button"
        >
          SIGN IN TO FINISH REVIEWING
        </a>
      )}
    </div>
  );
};

export default Workflow;
